import { message } from "antd";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";

import ModalSelectProductView from "../../../components/modalSelectProduct";
import { convertVVolumeToVolume } from "../../../utils/format";
import { AddOrderDeliveryContext } from "./AddOrderDeliveryContext";

const ModalSelectProduct = ({
  visible = false,
  selectedProducts = [],
  wareHouseCode = "",
  branchCode = "",
  onCancel = () => undefined,
  id = "",
}) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchResult, setSearchResult] = useState();
  const [searchText, setSearchText] = useState("");
  const [filter, setFilter] = useState({ brand: "", category: "" });

  const addContext = useContext(AddOrderDeliveryContext);

  useEffect(() => {
    onSearchProduct();
    // Модал нээгдэхэд эхний жагсаалтыг нэг удаа татна.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const getProductLocationDetail = (item) => {
    let location = {
      productLocation: "",
      productLocationCode: "",
    };
    if (wareHouseCode) {
      location.productLocation = "W";
      location.productLocationCode = wareHouseCode;
      location.productPositionCode = item?.positionCode;
    }
    if (branchCode) {
      location.productLocation = "M";
      location.productLocationCode = branchCode;
    }
    return location;
  };

  const addProducts = (params = []) => {
    let products = params.map((item) => ({
      ...item,
      ...getProductLocationDetail(item),
    }));

    if (wareHouseCode) {
      addContext.addProductWarehouse(id, products);
    } else {
      addContext.addProductBranch(id, products);
    }
  };

  const handleCheckProduct = (i, checked) => {
    products[i].checked = checked;
    setProducts([...products]);
  };
  const SearchValueProduct = (val, event, page) => {
    setProducts([]);
    onSearchProduct(val, event, page);
  };

  const onSearchProduct = (val, event, page = 1, options = {}) => {
    // if (loading) return;
    setLoading(true);
    const searchValue = val || "";
    const {
      brand = filter.brand,
      category = filter.category,
      reset = false,
    } = options;
    setSearchText(searchValue);

    //Брэнд болон Категори filter
    const filterQuery = `${brand ? `&brand=${encodeURIComponent(brand)}` : ""}${
      category ? `&category=${encodeURIComponent(category)}` : ""
    }`;

    //Агуулахаас эсвэл салбараас бараа хайх
    const url = wareHouseCode
      ? `/api/v1/request/productSearch?query=${searchValue}&wareHouseCode=${wareHouseCode}${
          page ? `&page=${page}` : ""
        }${filterQuery}`
      : `/api/v1.0/product/search?query=${searchValue}${
          page ? `&page=${page}` : ""
        }${filterQuery}`;
    axios
      .get(url)
      .then(({ data }) => {
        setLoading(false);

        if (data.statusCode === 200) {
          setSearchResult(data.result);
          if (page === 1 && data?.result?.docs?.length === 0) {
            if (reset) setProducts([]);

            message.error("Таны хайсан бараа олдсонгүй!");
          }

          if (data?.result?.docs?.length > 0) {
            const resProducts = data.result.docs.map((item) => {
              let obj = {
                ...item,
                totalUnit: 0,
              };
              if (wareHouseCode) {
                obj.volume = convertVVolumeToVolume(item.vVolume);
              }
              return obj;
            });

            selectedProducts?.forEach((item) => {
              for (const product of resProducts) {
                if (item._id === product?._id) {
                  product.checked = true;
                  break;
                }
              }
            });

            setProducts((prev) => [
              ...(!reset &&
              searchText === searchValue &&
              searchResult?.page !== page
                ? prev
                : []),
              ...resProducts,
            ]);
            // setResultOfSearch(data.result);
          }
        }
      })
      .catch((e) => {
        setLoading(false);
      });
  };

  const onFilterChange = (key, value) => {
    const nextFilter = { ...filter, [key]: value || "" };
    setFilter(nextFilter);
    onSearchProduct(searchText, null, 1, { ...nextFilter, reset: true });
  };

  const onOk = () => {
    let selProdClone = [...selectedProducts];
    const listAdd = [];

    products.forEach((item) => {
      const isItemSelected = selectedProducts.find(
        (el) => el?._id === item?._id
      );

      if (item.checked && !isItemSelected) {
        // item.totalUnit = 0;
        listAdd.push(item);
      }
      if (!item.checked && isItemSelected) {
        selProdClone = selProdClone.filter((el) => el._id !== item._id);
      }
    });

    addProducts([...selProdClone, ...listAdd]);
    onCancel();
  };
  return (
    <ModalSelectProductView
      isModalVisible={visible}
      handleOk={onOk}
      handleCancel={onCancel}
      onSearchProduct={onSearchProduct}
      SearchValueProduct={SearchValueProduct}
      productList={products}
      searchText={searchText}
      searchResult={searchResult}
      handleCheckProduct={handleCheckProduct}
      loading={loading}
      showFilter
      filterValues={filter}
      onFilterChange={onFilterChange}
      centered
    />
  );
};

export default ModalSelectProduct;
